/**
 * Helpers MBWay: normalização e validação do telemóvel para o formato
 * "<prefixo> <numero>" que a gateway EasyPay exige.
 *
 * Auto-detecta prefixos PT/BR/ES/FR/UK/US e cai em fallback PT (351)
 * quando o utilizador insere só 9 dígitos. Partilhado entre o checkout
 * inicial (`MyCheckoutPayment`) e o change-payment numa encomenda já
 * existente (`MyOrderPayment`).
 */

const KNOWN_PREFIXES = ["351", "34", "55", "33", "44", "1"];

/** Normaliza o telemóvel MBWay para "<prefixo> <numero>". */
export function formatMbwayPhone(raw) {
  let s = String(raw || "").replace(/[^0-9+\s]/g, "").trim();
  if (!s) return "";
  if (s.startsWith("+")) s = s.slice(1);
  // Se já tem espaço, assumimos formato correcto.
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0]} ${parts.slice(1).join("")}`;
  // Sem espaço — tentamos detectar prefixo conhecido.
  for (const p of KNOWN_PREFIXES) {
    if (s.startsWith(p) && s.length > p.length + 6) return `${p} ${s.slice(p.length)}`;
  }
  // Fallback PT (se utilizador colou só 9 dígitos, assumimos 351).
  if (s.length === 9) return `351 ${s}`;
  return s; // o backend devolverá MBWayFormat e mostramos a mensagem
}

/** Devolve true se o telemóvel já está num formato aceitável (prefixo + número ≥7 dígitos). */
export function isValidMbwayPhone(raw) {
  const v = formatMbwayPhone(raw);
  const parts = v.split(" ").filter(Boolean);
  return parts.length === 2 && /^\d+$/.test(parts[0]) && /^\d+$/.test(parts[1]) && parts[1].length >= 7;
}
